<template>
  <div class="occupationSelect">
    <li>
      <label :for="`party${number}Occupation`">
        <span class="label">Occupation</span>
        <small class="hint"
          >If the occupation is not in the list or person {{ number }} is
          retired select 'Other'.</small
        >
      </label>
      <select
        :id="`party${number}Occupation`"
        :name="`party${number}Occupation`"
        v-model="personDetails.occupation"
      >
        <option selected disabled>- please select -</option>
        <option 
          v-for="(occupation, index) in occupations" 
          :key="index" 
          :value="camelize(occupation)">
          {{ occupation }}
        </option>
      </select>
    </li>
    <li v-if="personDetails.occupation === 'other'">
      <label :for="`party${number}OccupationOther`">
        <span class="label">Tell us the occupation</span>
        <small class="hint"
          >For example if retired, enter Retired Public Servant</small
        >
      </label>

      <input
        autocomplete="off"
        class="titleCaseOnFirstBlur"
        :id="`party${number}OccupationOther`"
        type="text"
        size="50"
        :name="`party${number}OccupationOther`"
        maxlength="255"
        role="presentation"
        v-model="personDetails.occupationOther"
      />
    </li>
  </div>
</template>


<script>
const occupations = require('../../../../options.js')

export default {
  props: {
    number: String,
    value: Object,
  },
  data() {
    return {
      occupations: occupations.occupations
    }
  },
  computed: {
    personDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      }).replace(/\s+/g, '');
    },
  }
};
</script>
